import ModelService from "./abstract/ModelService";
import Client from "../models/Client";

export default class ClientService extends ModelService {
    constructor() {
        super('/clients', Client);
    }
}
